import { Period } from '@brighte/validation';
import { Alert } from '@spark-web/alert';
import { Text } from '@spark-web/text';
import {
  FINANCIAL_FIELD_TYPE_TEXT,
  FINANCIAL_MONTHLY_THRESHOLD_CONFIGURATION,
  FinancialFieldTypes,
  convertAmountToMonthlyPeriod,
  formatDollars,
} from '@utils';

type FinancialAlertBannerProps = {
  amount: number;
  period: Period;
  financialFieldType: FinancialFieldTypes;
};

function FinancialAlertBanner({ amount, period, financialFieldType }: FinancialAlertBannerProps) {
  const monthlyAmount = convertAmountToMonthlyPeriod(amount, period);

  const isAlertVisibleBasedOnThreshold = () => {
    switch (financialFieldType) {
      case FinancialFieldTypes.PRIMARY:
      case FinancialFieldTypes.JOINT:
        return (
          monthlyAmount < FINANCIAL_MONTHLY_THRESHOLD_CONFIGURATION?.income?.minimum ||
          monthlyAmount > FINANCIAL_MONTHLY_THRESHOLD_CONFIGURATION?.income?.maximum
        );
      case FinancialFieldTypes.MORTGAGE:
        return (
          monthlyAmount < FINANCIAL_MONTHLY_THRESHOLD_CONFIGURATION?.mortgageRepayment?.minimum ||
          monthlyAmount > FINANCIAL_MONTHLY_THRESHOLD_CONFIGURATION?.mortgageRepayment?.maximum
        );
      case FinancialFieldTypes.RENT:
        return (
          monthlyAmount < FINANCIAL_MONTHLY_THRESHOLD_CONFIGURATION?.rent?.minimum ||
          monthlyAmount > FINANCIAL_MONTHLY_THRESHOLD_CONFIGURATION?.rent?.maximum
        );
      case FinancialFieldTypes.INVESTMENT_PROPERTIES:
        return (
          monthlyAmount < FINANCIAL_MONTHLY_THRESHOLD_CONFIGURATION?.investmentProperties?.minimum ||
          monthlyAmount > FINANCIAL_MONTHLY_THRESHOLD_CONFIGURATION?.investmentProperties?.maximum
        );
      default:
        return false;
    }
  };

  if (!isAlertVisibleBasedOnThreshold()) {
    return null;
  }

  return (
    <Alert tone="info">
      <Text>
        Before you continue, please check that{' '}
        {formatDollars(monthlyAmount, { hideZeroCents: true, zeroValue: '$0.00' })} per{' '}
        <Text weight="semibold" inline>
          month
        </Text>{' '}
        is your correct {FINANCIAL_FIELD_TYPE_TEXT[financialFieldType]}
      </Text>
    </Alert>
  );
}

export default FinancialAlertBanner;
